  <template>
  <div role="group" class="b-form-group form-group">
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('START')">
          <inputvalidation :formerror="formError" name="name">
            <timepickersec format="hh:mm A" :minute-interval="15" v-model="formData.startTimeOut" :hour-range="hours"></timepickersec>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('END')">
          <inputvalidation :formerror="formError" name="name">
            <timepickersec format="hh:mm A" :minute-interval="15" v-model="formData.endTimeOut" :hour-range="hours"></timepickersec>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    
    <div class="form-row">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('ADDITIONALOPERATIONALHOURS')">
          <inputvalidation :formerror="formError" name="additionalTime">
            <b-form-select :options="optionalHorus" v-model="formData.additionalTime"></b-form-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mt-2">
      <div class="col-sm-12">
        <p><b>Import Note:</b></br></br>
              <i>Sales Hours and Break Hours are automatically calculated - as well as any operational hours that may occur outside store hours. </br></br>
              If you need to add additional operation hours for this particular employee (i.e. for training and/or other duties) - please indicate the number of hours within the shift above that need to be operational in nature on top of the hours automatically calculated.</i>
        </p>
      </div>
    </div>
  </div>
  </template>

  <script>

  export default {
    name: 'ScheduleForm',
    props: ['formData', 'formError', 'optionalHorus', 'hours'],
    data: function() {
      return {

      }
    },
    created() {
      var me = this;
    },
    methods: {

    },
    computed: {

    }
  }
  </script>
